import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RecuperaConfiguracionAplicacionApiService } from '../configuracion-rlt/services/recupera-configuracion-aplicacion-api.service';
import { environment } from 'src/environments/environment';
import { DatosFirmaService } from '../../panelControl/services/datos-firma.service';

@Component({
  selector: 'app-configuracion-page',
  templateUrl: './configuracion-page.component.html',
  styleUrls: ['./configuracion-page.component.css']
})
export class ConfiguracionPageComponent {

  numDosieresIncompletos: string = '-';
  moduloRltActivo: boolean = false;
  mostrarUsuarios: boolean;

  constructor(private router: Router,
              public recuperaConfiguracionAplicacionService: RecuperaConfiguracionAplicacionApiService,
              private datosFirmaService: DatosFirmaService){}

  async ngOnInit(){
    this.getResumenInicial();
    if(environment.LoginUniversal) this.mostrarUsuarios = true;
    else this.mostrarUsuarios = false;
    this.getModulosActivos();
  }

  navegar(ruta:string){
    this.router.navigate([ruta])
  }

  async getModulosActivos() {
    try {
      const result = await this.recuperaConfiguracionAplicacionService.getModulosActivos().toPromise();
      this.moduloRltActivo = result.ModuloRltActivo;
    } catch (error) {
      console.log(error);
      this.moduloRltActivo = false;
    }
  }

  getResumenInicial(){
    if(this.datosFirmaService.resumenInicial){
      this.numDosieresIncompletos = this.datosFirmaService.resumenInicial.DosieresIncompletos.toString();
    }else{
      this.datosFirmaService.cargaResumenHome([]).subscribe((response: any) => {
        this.numDosieresIncompletos = response.DosieresIncompletos.toString();
      });
    }
  }
}
